import React from "react";
import { useTheme } from "@material-ui/core/styles";
import LockIcon from "@material-ui/icons/Lock";

import AvisoAcesso from "../../components/AvisoAcesso";

// Sessão perdida (token expirado, 401, ou acesso direto a uma rota sem estar autenticado).
//
// Antes o Route.js simplesmente não renderizava nada nesse caso — a tela ficava branca, sem
// dizer o que aconteceu. Não faz sentido mostrar formulário de login aqui: o acesso ao
// Whaticket é sempre pelo deep link montado pelo ERP, com credenciais derivadas do usuário.
const SessaoEncerrada = () => {
	const theme = useTheme();

	return (
		<AvisoAcesso
			icone={<LockIcon />}
			corIcone={theme.palette.text.secondary}
			titulo="Sua sessão foi encerrada"
			mensagem="Para continuar o atendimento, acesse novamente pelo ERP."
		/>
	);
};

export default SessaoEncerrada;
